<template>
  <v-container fluid fill-height id="scrolling-techniques-7" class="overflow-y-auto" key="register">
    <transition name="router-anim" mode="out-in">
      <v-row>
        <v-col>
          <v-form
            ref="form"
            v-model="valid"
            class="px-5"
          >
            <template v-if="userId">
              <div class="display-1 font-weight-bold text--primary mb-8 w-80">
                {{ $t('Edycja-uzytkownika') }}
              </div>
            </template>
            <template v-else>
              <div class="display-1 font-weight-bold text--primary mb-3">
                {{ $t('dodaj-uzytkownika') }}
              </div>
              <div class="font-weight-light mb-6 c-lighter-1">
                {{ $t('new-user-info') }}
              </div>
            </template>

            <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
            :readonly="(userId) ? true : false"
            ></v-text-field>

            <v-radio-group v-model="permission" :mandatory="false">
              <v-radio v-if="isOwner" :label="$t('Wlasciciel')" value="666" color="primary"></v-radio>
              <v-radio :label="$t('Pelna-kontrola')" value="1" color="primary"></v-radio>
              <v-radio :label="$t('Tylko-odczyt')" value="2" color="primary"></v-radio>
              <v-radio v-if="userId" :label="$t('Brak-uprawnien')" value="0" color="primary"></v-radio>
            </v-radio-group>
            
            <div class="text-center mt-8">
              <v-btn 
              :loading="saving"
              :disabled="saving" 
              @click="postForm"
              x-large class="w-100" color="primary">{{ $t('zapisz') }}</v-btn>
            </div>
            <div class="text-center mt-2">
              <v-btn x-large text class="w-100" :to="'/users/' + controllerId">{{ $t('anuluj') }}</v-btn>
            </div>

          </v-form>
        </v-col>
      </v-row>
    </transition>

  </v-container>
</template>

<script>
  export default {
    data: () => ({
      permission: null,
      email: null,
      valid: false,
      emailRules: [
        v => !!v || 'Wypełnij E-mail',
        v => /.+@.+/.test(v) || 'E-mail jest nieprawidłowy'
      ],
      saving: false,
      success: false
    }),
    computed: {
      controllerId() {
        return this.$route.params.controllerId;
      },
      userId() {
        return this.$route.params.userId;
      },
      user() {
        return this.$store.getters['users/userByEmail'](this.userId) 
      },
      isOwner() {
        if (typeof this.user !== 'object') {
          return false;
        } else if (this.user.permission == 0) {
          return true;
        } else {
          return false;
        }
      }
    },
    created () {
      if (!(this.$store && this.$store.state && this.$store.state['users'])) {
        this.$router.push({ path: '/dashboard/' + this.controllerId });
      } else if (this.userId && typeof this.user !== 'object') {
        this.$router.push({ path: '/users/' + this.controllerId });
      } else if (this.userId) {
        this.email = this.userId;
        if (this.user.permission == 0) {
          this.permission = '666';
        } else {
          this.permission = this.user.permission.toString();
        }
      }
    },
    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      postForm () {
        if (!this.email) {
          this.$store.commit("alert", {
            color: "error",
            text: '1'
          });
        } else if (!this.permission) {
          this.$store.commit("alert", {
            color: "error",
            text: '73'
          });
        } else if (this.permission == '666' || this.permission == 666) {
          this.$router.push({ path: '/users/' + this.controllerId });
        } else {
          this.$store.dispatch('users/saveUser', { 
            email: this.email,
            permission: this.permission,
            controllerId: this.controllerId
          })
          .then(res => {
            this.saving = false;
            if (res.error) {
              this.$store.commit("alert", {
                color: "error",
                text: res.error.code
              });
            } else {
              this.$router.push({ path: '/users/' + this.controllerId });
            }
          });
        }
      }
    }
  }
</script>

<style>
</style>

